import { first, isEmpty } from 'lodash';

import {
  AugmentedCreateEntityNotesInput,
  AugmentedUpdateEntityInput,
  AugmentedUpdateEntityNotesInput,
} from '@/types/schema';

import { EntityDetail_DeathOrderNoteFragment } from '../../details/graphql/EntityDetailPage.generated';

export function makeUpdateEntityInput({
  entityId: entityID,
  householdId: householdID,
  newNotes,
  oldNotes,
  activeDeathOrderId,
  isTimeBoundEntity,
  syncDeathOrderNotes,
}: {
  entityId: string;
  householdId: string;
  activeDeathOrderId: string | null;
  newNotes: string;
  oldNotes?: EntityDetail_DeathOrderNoteFragment[] | null;
  isTimeBoundEntity: boolean;
  syncDeathOrderNotes: boolean;
}): AugmentedUpdateEntityInput {
  const updateDeathOrderNotes: AugmentedUpdateEntityNotesInput[] = [];
  const withDeathOrderNotes: AugmentedCreateEntityNotesInput[] = [];

  if (isTimeBoundEntity || syncDeathOrderNotes || !activeDeathOrderId) {
    const oldNote = first(oldNotes?.filter((n) => !n.clientProfile));
    if (oldNote) {
      updateDeathOrderNotes.push({
        id: oldNote.id,
        update: {
          notes: newNotes,
        },
      });
    } else {
      withDeathOrderNotes.push({
        create: {
          notes: newNotes,
          householdID,
        },
      });
    }
  } else {
    const oldNote = oldNotes?.find(
      ({ clientProfile }) => clientProfile?.id === activeDeathOrderId
    );
    if (oldNote) {
      updateDeathOrderNotes.push({
        id: oldNote.id,
        update: {
          notes: newNotes,
        },
      });
    } else {
      withDeathOrderNotes.push({
        create: {
          clientProfileID: activeDeathOrderId,
          notes: newNotes,
          householdID,
        },
      });
    }
  }

  const output: AugmentedUpdateEntityInput = {
    id: entityID,
    update: {},
    withDeathOrderNotes: isEmpty(withDeathOrderNotes)
      ? undefined
      : withDeathOrderNotes,
    updateDeathOrderNotes: isEmpty(updateDeathOrderNotes)
      ? undefined
      : updateDeathOrderNotes,
  };

  return output;
}
